const $ = jQuery;
$(function () {

    // Init jQuery Validation for login & registration forms
    function initResetLostFormsValidation() {
        // If jQuery Validation plugin is not loaded – do nothing
        if (typeof $.fn.validate !== 'function') {
            return;
        }

        // LOGIN FORM
        var $lostResetForm = $('form.lost_reset_password');
        if ($lostResetForm.length && !$lostResetForm.data('validator')) {
            // Disable native browser validation
            $lostResetForm.attr('novalidate', 'novalidate');

            $lostResetForm.validate({
                // Use span as error element
                errorElement: 'span',
                errorClass: 'woocommerce-input-error',

                // Place error messages for inputs except checkbox/radio
                errorPlacement: function (error, element) {
                    // Skip messages for checkboxes & radios
                    if (element.is(':checkbox') || element.is(':radio')) {
                        return;
                    }

                    const $row = element.closest('.form-row');

                    if ($row.length) {
                        error.insertAfter($row);
                    } else {
                        error.insertAfter(element);
                    }
                },

                // Remove error element from DOM when field becomes valid
                success: function (label, element) {
                    const $el = $(element);

                    let btn = $el.closest('form').find('[type=submit]');

                    if(btn.is(':disabled')) {
                        btn.attr('disabled', false);
                    }

                    // Skip checkboxes/radios
                    if ($el.is(':checkbox') || $el.is(':radio')) {
                        return;
                    }

                    // Completely remove error span from DOM
                    $(label).remove();
                }
            });
        }
    }

    // Init once on DOM ready
    initResetLostFormsValidation();
});